import {TimeUtils, UuidUtils} from '@vdw/angular-component-library';
import {DateTime, Duration} from 'luxon';

export class BreakTime {
  private _id: number | string;
  private _startTime: Duration;
  private _duration: number;

  public constructor(id: number | string, startTime: Duration, duration: number) {
    this._id = id;
    this._startTime = startTime;
    this._duration = duration;
  }

  public get id(): number | string {
    return this._id;
  }

  public set id(value: number | string) {
    this._id = value;
  }

  public get startTime(): Duration {
    return this._startTime;
  }

  public set startTime(value: Duration) {
    this._startTime = value;
  }

  public get duration(): number {
    return this._duration;
  }

  public set duration(value: number) {
    this._duration = value;
  }

  public static fromJSON(breakTimeJSON: any): BreakTime {
    const startTime = TimeUtils.convertTimeSpanToDuration(breakTimeJSON.startTimeFromMidnight);
    return new BreakTime(breakTimeJSON.id, startTime, TimeUtils.convertTimeSpanToDuration(breakTimeJSON.endTimeFromMidnight).minus(startTime).as('minutes'));
  }

  public static fromPreviewJSON(breakTimeJSON: any, startDate: DateTime): BreakTime {
    const start = DateTime.fromISO(breakTimeJSON.start);
    return new BreakTime(UuidUtils.generateV4Uuid(), start.diff(startDate, ['days', 'hours', 'minutes']), DateTime.fromISO(breakTimeJSON.end).diff(start).as('minutes'));
  }

  public toJSON(): JSON {
    return {
      id: typeof this._id === 'number' ? this._id : undefined,
      startTimeFromMidnight: this._startTime.toFormat('d:hh:mm:ss'),
      endTimeFromMidnight: this._startTime.plus({minutes: this.duration}).toFormat('d:hh:mm:ss')
    } as any as JSON;
  }
}
